import React, { Component } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import logo from "../aplogo1.png";
import { ButtonContainer } from "./Button";
import firebase from './Fireb'
import Swal from 'sweetalert2';
export default class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: firebase.auth().currentUser,
      record: []
    };
    this.logout = this.logout.bind();
}
      logout = () => {
        firebase.auth().signOut().then((user) => {
            this.setState({
              user: null
            });
          })
  
    
}
componentDidMount() {
const ref1 = firebase.firestore().collection('record').doc(firebase.auth().currentUser.uid);
    ref1.get().then((doc) => {
      if (doc.exists) {
        this.setState({
          record: doc.data(),
          key1: doc.id,
          isLoading: false
        });
      } else {
        console.log("No such document!");
      }
    });
  }
  rendercheck() {
   
  if (this.state.record.student == false) {
    return (
      <Nav className="navbar navbar-expand-sm  navbar-dark px-sm-5">
        {/* 
https://www.iconfinder.com/icons/1243689/call_phone_icon
Creative Commons (Attribution 3.0 Unported);
https://www.iconfinder.com/Makoto_msk */}
        
          <img src={logo}  style={{position:"absolute"}}alt="store" className="navbar-brand" />
          <h1 style={{fontSize: 15, fontWeight: 400, paddingTop: '80px',fontFamily: 'Brush Script MT, Brush Script Std, cursive	', color: 'white', paddingLeft: '12px'}}>Cashless </h1>
        
        <ul className="navbar-nav align-items-center" >
          <li style={{paddingLeft:'100px',fontWeight:500}} >
            <Link to="/" className="nav-link">
            <ButtonContainer>
            <span className="mr-2">
              <i class="fas fa-boxes"/>
            </span>
             products
          </ButtonContainer>
            </Link>
          </li>
        </ul>

      
        <ul className="navbar-nav align-items-center" >
          <li style={{fontWeight:500}} >
            <Link to="/Add" className="nav-link">
            <ButtonContainer>
            <span className="mr-2">
            <i class="fas fa-plus-square"/>
            </span>
             Add products
          </ButtonContainer>
            </Link>
          </li>
        </ul>


        <ul className="navbar-nav align-items-center" >
          <li style={{fontWeight:500}} >
            <Link to="/paymentl" className="nav-link">
            <ButtonContainer>
            <span className="mr-2">
            <i class="fas fa-file-invoice-dollar"/>
            </span>
             Payments
          </ButtonContainer>
            </Link>
          </li>
        </ul>
           
        <ul className="navbar-nav align-items-center" >
          <li style={{fontWeight:500}} >
            <Link to="/transactionl" className="nav-link">
            <ButtonContainer>
            <span className="mr-2">
            <i class="fas fa-receipt"/>
            </span>
             Transactions
          </ButtonContainer>
            </Link>
          </li>
        </ul>

        <Link to="/cart" className="ml-auto">
          <ButtonContainer>
            <span className="mr-2">
              <i className="fas fa-cart-plus " />
            </span>
             cart
          </ButtonContainer>
        </Link>
      
                <li>
      
          <ButtonContainer onClick={this.logout}>
            <span className="mr-2">
              <i className="fas fa-sign-out-alt" />
            </span>
             Logout
          </ButtonContainer>
        
        </li>
       </Nav>
    );
}
  }
  rendercheck2()
  { 
    
    if (this.state.record.student == true) {
   
    return(
      <div className="container">
        <Nav className="navbar navbar-expand-sm  navbar-dark px-sm-5">
        {/* 
https://www.iconfinder.com/icons/1243689/call_phone_icon
Creative Commons (Attribution 3.0 Unported);
https://www.iconfinder.com/Makoto_msk */}
        <Link to="/">
          <img src={logo} alt="store" className="navbar-brand" />
        </Link>
        <ul className="navbar-nav align-items-center" ></ul>
        <li>
      
      <ButtonContainer onClick={this.logout}>
        <span className="mr-2">
          <i className="fas fa-sign-out-alt" />
        </span>
         Logout
      </ButtonContainer>
    </li>
   </Nav>
      </div>
    )}
  
  }
  render() {
    if(this.state.user == null) {
      return window.location.reload();
  }
    return (
     <div>
    {this.rendercheck()}
    
    {this.rendercheck2()}
    
        </div>
    )
  }
  
}

const Nav = styled.nav`
  background-image: linear-gradient(to left, #000428 , #004e92);

  .nav-link {
    color: var(--mainWhite) !important;
    font-size:1.3rem;
    text-transform:capitalize;
  }
  @media (max-width: 576px) {
    .navbar-nav {
      flex-direction: row !important;
`;

// const ButtonContainer = styled.button`
//   text-transform: capitalize;
// font - size: 1.4rem;
// background: transparent;
// border: 0.05rem solid var(--lightBlue);
// border - radius: 0.5rem;
// padding: 0.2rem 0.5rem;
// outline - color: red;
// cursor: pointer;
// display: inline - block;
// margin: 0.2rem 0.5rem 0.2rem 0;
// transition: all 0.5s ease -in -out;
//   &: hover {
//   background: var(--lightBlue);
//   color: var(--mainBlue);
// }
// `;